module.exports = "/_next/static/images/9b560a943bd93577f65a6ebec4e25a93-walmart-icon.svg.webp";